import { Component } from '@angular/core';
import { ApplicationFilesService } from '../../shared/services/application-files.service';

@Component({
  selector: 'ins-irrigation-insurance',
  templateUrl: './irrigation-insurance.component.html',
})
export class IrrigationInsuranceComponent {
  constructor(private appFilesService: ApplicationFilesService) {}

  downloadClaimPacket(): void {
    this.appFilesService.downloadFile('Claim Forms\\Claim Packet.pdf');
  }
}
